// @flow

import { StyleSheet, Dimensions } from 'react-native';

export const BASE_HEIGHT = 1080;
export const HEIGHT_RATIO: number = Dimensions.get('window').height / BASE_HEIGHT;

export const adaptToPixelRatio = (originalValue: number): number => (
    originalValue * HEIGHT_RATIO
);

export const PRIMARY_COLOR = '#bfcd31';
export const WHITE_COLOR = '#ffffff';
export const TRANSPARENT_BLACK_COLOR = 'rgba(0, 0, 0, 0.35)';
export const OPAQUE_BLACK_COLOR_1_3 = 'rgba(0, 0, 0, 0.7)';
export const OPAQUE_BLACK_COLOR_75 = 'rgba(0, 0, 0, 0.75)';
export const OPAQUE_BLACK_COLOR_35 = 'rgba(0, 0, 0, 0.35)';
export const DARK_COLOR = '#1a1a1a';
export const BLACK_COLOR = '#000000';
export const LIGHT_BLACK_GRAY_COLOR = '#0E0E12';
export const BLACK_GRAY_COLOR = '#040405';
export const DARK_GRAY_COLOR = '#333333';
export const GRAY_COLOR = '#6e7482';
export const TRANSPARENT_COLOR = 'transparent';
export const BLUE_COLOR = '#0080b4';
export const RED_COLOR = 'red';
export const LIGHT_GREY_COLOR = '#f1f1f3';

export const OVERLAY_TITLE_COLOR = WHITE_COLOR;
export const OVERLAY_CONTROLS_SIZE: number = adaptToPixelRatio(100);

export const FOCUSED_ELEMENT_BORDER_WIDTH: number = adaptToPixelRatio(2);

export const SETTINGS_STRIP_SIZE: number = adaptToPixelRatio(120);

export const CONTROLS_SEPARATOR_SIZE: number = adaptToPixelRatio(30);

const _textShadow = {
    common: {
        textShadowColor: 'rgba(0, 0, 0, 0.4)',
        textShadowRadius: 2,
        textShadowOffset: { width: 1, height: 1 },
    },
};
export const textShadow: typeof _textShadow = StyleSheet.create(_textShadow);
